module.exports = __webpack_public_path__ + "static/media/bgDoor1.0d6412d7.mp3";